import useUploadsInFlight from '../../hooks/upload/useUploadsInFlight';
import { inflightRegistry } from '../../domain/services/upload/upload.inflight.registry';

export const UPLOAD_LOCK_HINT = 'aguarde o envio terminar';

const LOCKED_OPACITY = 0.5;

const LOCKED_STYLE = Object.freeze({ opacity: LOCKED_OPACITY, cursor: 'not-allowed' });

export const lockedStyle = (inFlight) => (inFlight ? { ...LOCKED_STYLE } : {});

export const whenNoUpload = (action) => (...args) => (inflightRegistry.count() === 0 ? action(...args) : undefined);

export default function UploadLock({ children }) {
    const { inFlight } = useUploadsInFlight();
    return children(inFlight);
}
